// extracted by mini-css-extract-plugin
export default {"quantity_wrapper":"U4","increment":"V4","decrement":"W4","product":"X4","product_info":"Y4","text":"Z4","modify_btn":"a5","controls":"b5","price":"c5","deliveredOnce":"e5"};
    if(module.hot) {
      // 1737143664692
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  